// extracted by mini-css-extract-plugin
module.exports =  {"popover-trigger-wrapper":"hx1y6S5","popoverTriggerWrapper":"hx1y6S5","hide-trigger":"FOG2Iy9","hideTrigger":"FOG2Iy9"};